module.exports = __webpack_public_path__ + "img/shopping-icon.c87d1be9.png";